// src/components/StoryBanner.js
const LINES = {
  1: "The fog lifts over the Ruined Vale. A lone hero steps forward.",
  3: "Rumors speak of a blacksmith who forges blades from fallen stars.",
  5: "A crimson moon rises. Beasts grow restless.",
  8: "You find a tattered map: 'Beyond wave 10 lies the Gate.'",
};

export default function StoryBanner({ wave, onClose }) {
  const text = LINES[wave];
  if (!text) return null;
  return (
    <div className="modal">
      <div className="modal-card">
        <h2>Chapter {wave}</h2>
        <p style={{opacity:.9, lineHeight:1.6}}>{text}</p>
        <div className="row">
          <button className="btn primary" onClick={onClose}>Onward</button>
        </div>
      </div>
    </div>
  );
}
